export const formatMoney = (num, currency = '$') => {
  if (isNaN(num)) {
    return '-'
  }

  return `${currency}${Number(num)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;
}

export const formatCurrencyWithCentsInput = value => {
  if (typeof value === 'number') {
    value = value.toFixed(2);
  } else if (typeof value !== 'string') {
    value = value.toString();
  }

  value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `$${value}`;
};

export const formatValueAsCurrency = (value) => {
  if (typeof value === "string" && value.includes('$')) {
    return value;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value || 0)
}

export const currencyToNumber = (value) => {
  const cleanValue = value.replaceAll(/[$,]/g, '')
  return Number(cleanValue);
}

export const formatValueAsCurrencyOnBlur = (value) => {
  const number = currencyToNumber(value);
  if (Number.isNaN(number)) {
    return value;
  }

  return formatValueAsCurrency(number);
}

export default formatMoney;
